import { Box, Container } from '@mui/material';
import { Footer } from 'components/common/Footer';
import { Outlet } from 'react-router-dom';

export function MinimalLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Container disableGutters maxWidth={false}>
          <Outlet />
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}
